module.exports = __webpack_public_path__ + "static/icons/icon-heart-e9f288afb21bb022c081b7f618731501.svg";